import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { AuthProvider } from './context/Auth';
import { PrivateRoutes } from './components/PrivateRoutes';
import { PublicRoute } from './components/PublicRoute';
import { lazy, Suspense } from 'react';
import { Spin } from 'antd';

const PromoterHome = lazy(() => import('./pages/PromoterHome'));
const Transaction = lazy(() => import('./pages/Transaction'));
const Login = lazy(() => import('./pages/Login'));
const SingleTransaction = lazy(() => import('./pages/SingleTransaction'));

function App() {
	return (
		<AuthProvider>
			<BrowserRouter>
				<Suspense
					fallback={
						<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
							<Spin size="large" />
						</div>
					}
				>
					<Routes>
						<Route element={<PrivateRoutes />}>
							<Route path="/promoter" element={<PromoterHome />} />
							<Route path="/transaction" element={<Transaction />} />
							<Route path="/promoter/transaction/:id" element={<SingleTransaction />} />
						</Route>
						<Route element={<PublicRoute />}>
							<Route path="*" element={<Navigate to="/" replace />} />
							<Route path="/" element={<Login />} />
						</Route>
					</Routes>
				</Suspense>
			</BrowserRouter>
		</AuthProvider>
	);
}

export default App;
